import { render, staticRenderFns } from "./transactionRecord.vue?vue&type=template&id=235a149b&scoped=true&"
import script from "./transactionRecord.vue?vue&type=script&lang=js&"
export * from "./transactionRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235a149b",
  null
  
)

export default component.exports